export class Tablet {
  pdaUserId ;
  firstname = '';
  lastname = '';
  pin = '';
  pin2 = '';
  expired = false;
  expired_Formatted: string;
  created_Date: string;
  isLead = false


  is_edit = false;

  init(pdaUserId: number, firstname: string, lastname: string, pin: string, expired: boolean, isLead: boolean, created_Date: string) {
    this.pdaUserId = pdaUserId;
    this.firstname = firstname;
    this.lastname = lastname;
    this.pin = pin;
    this.expired = expired;
    this.isLead = isLead;
    this.created_Date = created_Date;

    this.expired_Formatted = expired ? 'Yes' : 'No';
  }
}
